/**
 * DistributionChart — class score-bucket bar chart.
 */
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import type { ClassStats } from "../api/school";

const BUCKET_LABELS: { key: keyof ClassStats["distribution"]; label: string; color: string }[] = [
  { key: "excellent_85_100", label: "优秀 85-100", color: "#10b981" },
  { key: "good_70_84", label: "良好 70-84", color: "#0ea5e9" },
  { key: "average_60_69", label: "一般 60-69", color: "#f59e0b" },
  { key: "needs_improvement_0_59", label: "待改进 0-59", color: "#ef4444" },
  { key: "not_assessed", label: "未评估", color: "#94a3b8" },
];

export function DistributionChart({
  distribution,
  height = 220,
}: {
  distribution: ClassStats["distribution"];
  height?: number;
}) {
  const data = BUCKET_LABELS.map((b) => ({
    label: b.label,
    count: distribution[b.key],
    color: b.color,
  }));

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 8, right: 16, left: -10, bottom: 8 }}>
        <CartesianGrid stroke="#e2e8f0" strokeDasharray="3 3" />
        <XAxis dataKey="label" tick={{ fill: "#64748b", fontSize: 11 }} />
        <YAxis allowDecimals={false} tick={{ fill: "#64748b", fontSize: 11 }} />
        <Tooltip
          contentStyle={{ fontSize: 12, borderRadius: 6 }}
          formatter={(v) => [`${v} 人`, ""]}
        />
        <Bar dataKey="count">
          {data.map((entry, i) => (
            <Cell key={i} fill={entry.color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
